class DomManipulate {
  constructor() { }

  onReady(callback) {
    document.addEventListener("DOMContentLoaded", () => {
      callback();
    });
  }

  onClickAll(selector, callback) {
    this.elements = document.querySelectorAll(selector);
    for (let i = 0; i < this.elements.length; i++) {
      if (!this.elements) {
        return
      }
      this.elements[i].addEventListener("click", () => {
        callback(this.elements[i]);
      });

    }
  }

  onClickOne(selector, callback) {
    this.element = document.querySelector(selector);
    if (this.element) {
      this.element.addEventListener("click", (event) => {
        callback(event);
      });
    }
  }
  onClickOneGMP(selector, callback) {
    this.element = document.querySelector(selector);
    if (this.element) {
      this.element.addEventListener("gmp-click", (event) => {
        callback(event);
      });
    }
  }
  onMouseOutAll(selector, callback) {
    this.elements = document.querySelectorAll(selector);
    for (let i = 0; i < this.elements.length; i++) {
      if (!this.elements) {
        return
      }
      this.elements[i].addEventListener("mouseout", () => {
        callback(this.elements[i]);
      });

    }
  }

  onScroll(callback) {
    document.onscroll(() => {
      callback();
    });
  }

  onSimulateClick(selector, callback) {
    this.element = document.querySelector(selector);
    if (this.element) {
      this.element = new MouseEvent("click", () => {
        callback();
      });
    }
  }

  onChange(selector, callback) {
    this.element = document.querySelector(selector);
    if (!this.element) {
      return
    }
    this.element.addEventListener("change", () => {
      callback(this.element.value);
    });
  }
}

export { DomManipulate as default };
